import type { VatCode } from "@/app/services/generated/vatcodeService";
import { vatCodeService } from "@/app/services/generated/vatcodeService";
import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasVatCodesCache {
  vatCodes: VatCodesCache;
}

// Singleton cache store
const vatCodesCacheStore = new EntityCacheStore<VatCode>(
  EnumCacheEntityType.vatCode,
  async () => vatCodeService.getAllVatCodes()
);

// Ephemeral reader
export default class VatCodesCache extends EntityWithGuidKeyCache<VatCode> {
  constructor() {
    super(vatCodesCacheStore, (x) => x.id);
  }
}
